import { clientSideOnly } from '../../lib/client-side-only'

import { type FeatureFlagMap, type FeatureFlagsAvailable } from './types'

export const STORAGE_KEY = 'featureFlags'

type FeatureFlagsStorageProps = { identifiers: string[]; featureFlags: FeatureFlagsAvailable[] }

export const FeatureFlagsStorage = {
  set({ identifiers, featureFlags }: FeatureFlagsStorageProps) {
    clientSideOnly(() => sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ identifiers, featureFlags })))
  },
  get(): FeatureFlagMap {
    const featureFlags = clientSideOnly(() => sessionStorage.getItem(STORAGE_KEY), '[]')

    return featureFlags ? JSON.parse(featureFlags) : { featureFlags: [], identifiers: [] }
  },
  clear() {
    sessionStorage.removeItem(STORAGE_KEY)
  }
}
